import * as React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Menu from '@App/components/blocks/Menu'
import { AppState } from 'reducers'
import { PageLayoutProps } from './types'
import { compose } from 'redux'

import './styles.scss'

class PageLayout extends React.Component<PageLayoutProps> {
  constructor(props: any) {
    super(props)
  }

  render() {
    const { children, currentPath } = this.props
    return (
      <div className="wrapper">
        <div className="wrapper__menu">
          <Menu
            currentPath={currentPath}
          />
        </div>
        <div className="content">
          {children}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: AppState) => {
  const {
    user: {
      user,
      currentApp,
    },
  } = state

  return {
    user,
    currentApp,
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps),
)(PageLayout)
